import { render, staticRenderFns } from "./ResourceMessageForm.vue?vue&type=template&id=b0199baa"
import script from "./ResourceMessageForm.vue?vue&type=script&lang=js"
export * from "./ResourceMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports